// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"83":"7140a118","216":"78ff8323","411":"a76fd1fd","540":"ecd61852","547":"3946945d","594":"095afae3","793":"279efc63","956":"2eef1b18"}[chunkId] + ".chunk.css";
};